<div class="auction-meta-card">
  <p class="auction-meta-card__label">{{ label() | translate }}</p>
  <p class="auction-meta-card__value" [class]="valueClass()">{{ value() }}</p>
</div>
